import { getVehicleTags } from '@cinch-labs/shared-util'
import type {
  DirectVehicleAdvertSummary,
  VehicleFilterResponseVehicle,
} from '@cinch-nx/data-vehicle'

import { ProductListCard } from './components/product-list-card/product-list-card'
import { Env, readFromEnv } from '@cinch-nx/environments'

export interface VehicleCardProps {
  id: string
  isSaved: boolean
  isPending: boolean
  isUnfavourited?: boolean
  linkToProductView?: boolean
  isAvailable?: boolean
  discountInPence?: number
  vehicle: VehicleFilterResponseVehicle | DirectVehicleAdvertSummary
  showActions?: boolean
  onSave?: (newVal: boolean) => void
  onCardClick?: () => void
  isSmallCardSize?: boolean
  showMonthlyPrice?: boolean
}

export const VehicleCard: React.FC<VehicleCardProps> = ({
  vehicle,
  id,
  isSmallCardSize = false,
  showMonthlyPrice = false,
  ...props
}) => {
  const {
    vehicleId,
    price,
    priceIncludingAdminFee,
    variant,
    make,
    selectedModel,
    isReserved,

    vehicleYear,
    discountInPence,
    thumbnailUrl,
    quoteRegularPaymentInPence,
    quoteType,
  } = vehicle

  const title = `${make} ${selectedModel}`
  const image: string = thumbnailUrl
    ? thumbnailUrl.replace(/0-(.*)-thumbnail\.([a-z]+)$/, '1-$1.$2')
    : ''

  const tags: { label: string; value: string }[] = getVehicleTags(vehicle)

  const hasAdminFeeComplianceBeenSet =
    readFromEnv(Env.AdminFeeCompliance) === 'true'

  const vehiclePrice = hasAdminFeeComplianceBeenSet
    ? priceIncludingAdminFee
    : price

  return (
    <ProductListCard
      id={vehicleId || id}
      price={vehiclePrice}
      image={image}
      title={title}
      subtitle={variant}
      tags={tags}
      isReserved={isReserved}
      make={make}
      model={selectedModel}
      vehicleYear={vehicleYear}
      discountInPence={discountInPence}
      isSmallCardSize={isSmallCardSize}
      showMonthlyPrice={showMonthlyPrice}
      quoteRegularPaymentInPence={quoteRegularPaymentInPence}
      quoteType={quoteType}
      {...props}
    />
  )
}

export default VehicleCard
